import { render, staticRenderFns } from "./BodyList.vue?vue&type=template&id=a2c23476&scoped=true&"
import script from "./BodyList.vue?vue&type=script&lang=js&"
export * from "./BodyList.vue?vue&type=script&lang=js&"
import style0 from "./BodyList.vue?vue&type=style&index=0&id=a2c23476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c23476",
  null
  
)

export default component.exports